import * as ActionTypes from '../ActionTypes';

export const GetMyAttendanceRegularizationAction = (params, callback) => {
    return {
        type: ActionTypes.GET_MY_ATTENDANCE_REGULARIZATION_REQUEST,
        params,
        callback
    }
}

export const UpsertMyAttendanceRegularizationAction = (params, callback) => {
    return {
        type: ActionTypes.UPSERT_MY_ATTENDANCE_REGULARIZATION_REQUEST,
        params,
        callback
    }
}

export const DeleteMyAttendanceRegularizationAction = (params, callback) => {
    return {
        type: ActionTypes.DELETE_MY_ATTENDANCE_REGULARIZATION_REQUEST,
        params,
        callback
    }
}

export const GetApproverEmpRegularizationMappingAction = (params, callback) => {
    return {
        type: ActionTypes.GET_APPROVER_EMP_REGULARIZATION_MAPPING_REQUEST,
        params,
        callback
    }
}

export const UpdateApproverEmpRegularizationMappingAction = (params, callback) => {
    return {
        type: ActionTypes.UPDATE_APPROVER_EMP_REGULARIZATION_MAPPING_REQUEST,
        params,
        callback
    }
}
